'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dSecret$0024$0024anon$0024148 from "./presto.types$-Seed-Secret$$anon$148.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SeedSecret$() {
  this.cb1 = null;
  this.cb2 = false;
}
export { $c_Lpresto_types$SeedSecret$ as $c_Lpresto_types$SeedSecret$ };
$p = $c_Lpresto_types$SeedSecret$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SeedSecret$;
/** @constructor */
function $h_Lpresto_types$SeedSecret$() {
}
export { $h_Lpresto_types$SeedSecret$ as $h_Lpresto_types$SeedSecret$ };
$h_Lpresto_types$SeedSecret$.prototype = $p;
$p.csw = (function() {
  if ((!this.cb2)) {
    this.cb1 = new $j_presto$002etypes$0024$002dSeed$002dSecret$0024$0024anon$0024148.$c_Lpresto_types$SeedSecret$$anon$148(this);
    this.cb2 = true;
  }
  return this.cb1;
});
var $d_Lpresto_types$SeedSecret$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SeedSecret$, "presto.types$SeedSecret$", ({
  a1t: 1,
  D: 1
}));
export { $d_Lpresto_types$SeedSecret$ as $d_Lpresto_types$SeedSecret$ };
var $n_Lpresto_types$SeedSecret$;
function $m_Lpresto_types$SeedSecret$() {
  if ((!$n_Lpresto_types$SeedSecret$)) {
    $n_Lpresto_types$SeedSecret$ = new $c_Lpresto_types$SeedSecret$();
  }
  return $n_Lpresto_types$SeedSecret$;
}
export { $m_Lpresto_types$SeedSecret$ as $m_Lpresto_types$SeedSecret$ };
//# sourceMappingURL=presto.types$-Seed-Secret$.js.map
